/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_EditInputs */



/**
* | output |
* | --- |
* | "Edit user" |
*
* @param {User_EditInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_edit = /** @type {((inputs?: User_EditInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_EditInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier l'utilisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar usuario")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Editar usuário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica utente")
	return /** @type {LocalizedString} */ ("Edit user")
});